import React, { useState, useEffect } from 'react';
import './App.css';
import Onboarding from './components/Onboarding';
import HabitTracker from './components/HabitTracker';

function App() {
  const [userProfile, setUserProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user has completed onboarding
    const savedProfile = localStorage.getItem('prettyHabitsProfile');
    if (savedProfile) {
      setUserProfile(JSON.parse(savedProfile));
    }
    setIsLoading(false);
  }, []);

  const handleOnboardingComplete = (profile) => {
    setUserProfile(profile);
    localStorage.setItem('prettyHabitsProfile', JSON.stringify(profile));
  };

  const resetProfile = () => {
    setUserProfile(null);
    localStorage.removeItem('prettyHabitsProfile');
    localStorage.removeItem('prettyHabitsData');
  };

  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading your skincare journey...</p>
      </div>
    );
  }

  return (
    <div className="App">
      {!userProfile ? (
        <Onboarding onComplete={handleOnboardingComplete} />
      ) : (
        <HabitTracker 
          userProfile={userProfile} 
          onResetProfile={resetProfile}
        />
      )}
    </div>
  );
}

export default App;
